/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH
 * under one or more contributor license agreements. Licensed under a proprietary license.
 * See the License.txt file for more information. You may not use this file
 * except in compliance with the proprietary license.
 */

import {del, get, post, put} from 'request';

export async function loadAlerts(collection) {
  const response = await get(`api/collection/${collection}/alerts`);
  return await response.json();
}

export async function addAlert(alert) {
  const response = await post(`api/alert`, alert);
  return await response.json();
}

export async function editAlert(id, alert) {
  return await put(`api/alert/${id}`, alert);
}

export async function removeAlert(id) {
  return await del(`api/alert/${id}`);
}
